module.exports = __webpack_public_path__ + "static/fonts/FranklinGothicMedium.09aff29.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/FranklinGothicMedium.ttf
// module id = 970
// module chunks = 113